import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  NgZone
} from '@angular/core';

@Directive({
    selector: '[appCheckFlexWrap]',
    standalone: false
})
export class CheckFlexWrapDirective implements AfterViewInit, OnDestroy {
  @Output() flexWrapped = new EventEmitter<{
    wrapped: boolean;
    startIndex?: number;
  }>();

  private resizeObserver!: ResizeObserver;
  private lastValue: boolean | null = null;
  private checkPending = false;
  private lastIndex:any = 0;

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => this.scheduleWrapCheck());
      this.resizeObserver.observe(this.el.nativeElement);

      // Also listen for window resize
      window.addEventListener('resize', this.handleWindowResize);

      // Initial check
      setTimeout(() => this.checkWrap(), 100);
    });
  }

  private handleWindowResize = () => {
    this.scheduleWrapCheck();
  };

  private scheduleWrapCheck() {
    if (!this.checkPending) {
      this.checkPending = true;
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.checkWrap();
          this.checkPending = false;
        }, 20); // small delay to ensure layout stabilizes
      });
    }
  }

  private checkWrap() {
    const children = Array.from(this.el.nativeElement.children) as HTMLElement[];

    if (children.length === 0) {
      this.updateValue({ wrapped: false });
      return;
    }

    // Clean up previous classes
    children.forEach(child => {
      child.classList.remove('du-wrapped-first', 'du-wrapped-last');
    });

    const firstChildTop = children[0].offsetTop;
    let startIndex: number | undefined;

    // Group children by row based on offsetTop
    let currentTop = firstChildTop;
    let currentRowStart = 0;
    const rows: { start: number; end: number }[] = [];

    for (let i = 1; i < children.length; i++) {
      if (children[i].offsetTop > currentTop) {
        rows.push({ start: currentRowStart, end: i - 1 });
        if (startIndex === undefined) startIndex = i;
        currentRowStart = i;
        currentTop = children[i].offsetTop;
      }
    }
    rows.push({ start: currentRowStart, end: children.length - 1 });

    // Add centering classes to each wrapped row (skip first row)
    for (let r = 1; r < rows.length; r++) {
      children[rows[r].start].classList.add('du-wrapped-first');
      children[rows[r].end].classList.add('du-wrapped-last');
    }

    const isWrapped = startIndex !== undefined;
    this.updateValue({ wrapped: isWrapped, startIndex });
  }

  private updateValue(value: { wrapped: boolean; startIndex?: number }) {
    // if (this.lastValue !== value.wrapped || this.lastIndex !== value.startIndex) {
      this.lastValue = value.wrapped;
      this.lastIndex = value.startIndex;
      this.ngZone.run(() => this.flexWrapped.emit(value));
    // }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.handleWindowResize);
  }
}
